import 'intl';
import 'intl/locale-data/jsonp/en';
import Web3 from "web3";
import * as Contract from "../config/Contract.json";
import { validate, Network } from 'bitcoin-address-validation';
import { isValidAddress } from 'ethereumjs-util';
import BTC from '../images/coin/btc.png'
import ORDI from '../images/coin/ordi.png'
import SATS from '../images/coin/sats.png'
import RATS from '../images/coin/rats.png'
import unknowCoinIcon from '../images/coin/unknown.png';



export const FormatNumber = (number) => {
    if (!isNaN(number)) {
        return Intl.NumberFormat().format(number);
    }
}

export function getIcons_old(name, map, isSmall) {
    if (name) {
        if (Object.keys(map).length !== 0 && map[name] !== undefined) {
            let url = ''
            if (isSmall) {
                url = map[name].smallLogoUrl === undefined || map[name].smallLogoUrl === null ? '' : map[name].smallLogoUrl
            } else {
                url = map[name].bigLogoUrl === undefined || map[name].bigLogoUrl === null ? '' : map[name].bigLogoUrl
            }
            return url === '' ? unknowCoinIcon : url
        } else {
            return unknowCoinIcon

        }
    } else {
        return unknowCoinIcon
    }
}

export function getIcons(name) {
    if (name) {
        if (name.toUpperCase() === 'BTC') {
            return BTC
        } else if (name.toUpperCase() === 'ORDI') {
            return ORDI
        } else if (name.toUpperCase().includes('RSIC')) {
            return 'https://assets.coingecko.com/coins/images/37157/standard/runecoin.jpeg'    
        } 
        
        /** Adding top BRC20 coin icons */

        else if (name.toUpperCase().includes('SATS')) {
            return SATS
        } else if (name.toUpperCase().includes('WZRD')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/30491.png'
        } else if (name.toUpperCase().includes('LEVER')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/20873.png'
        } else if (name.toUpperCase().includes('PUPS')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/30484.png'
        } else if (name.toUpperCase().includes('MUBI')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/28412.png'
        } 
        
        else if (name.toUpperCase().includes('TRAC')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/25208.png'
        } else if (name.toUpperCase().includes('ORNJ')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/29297.png'
        } else if (name.toUpperCase().includes('BEFI')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/29170.png'
        } else if (name.toUpperCase().includes('OXBT')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/26034.png'
        } else if (name.toUpperCase().includes('RATS')) {
            return RATS
        } 
        
        else if (name.toUpperCase().includes('1CAT')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/28791.png'
        } else if (name.toUpperCase().includes('ORDS')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/28920.png'
        } else if (name.toUpperCase().includes('MICE')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/28775.png'
        } else if (name.toUpperCase().includes('BSSB')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/28608.png'
        } else if (name.toUpperCase().includes('TURT')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/28826.png'
        } 
        
        else if (name.toUpperCase().includes('BIIS')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/28759.png'
        } else if (name.toUpperCase().includes('.COM')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/28737.png'
        } else if (name.toUpperCase().includes('DOVI')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/28662.png'
        } else if (name.toUpperCase().includes('BNSX')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/28751.png'
        } else if (name.toUpperCase().includes('O4DX')) {
            return 'https://s2.coinmarketcap.com/static/img/coins/64x64/30282.png'
        } 
        
        else {
            return BTC
        }
    } else {
        return unknowCoinIcon
    }
}

export function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export const convertTimeString = (timeString) => {
    const availableTime = new Date((Date.parse(timeString)));
    const minute = availableTime.getUTCMinutes() >= 10 ? availableTime.getUTCMinutes() : '0' + availableTime.getUTCMinutes().toString()
    return availableTime.getUTCFullYear() + '-' + (availableTime.getUTCMonth() + 1) + '-' + availableTime.getUTCDate() + ' ' +
        ('0' + availableTime.getUTCHours()).slice(-2) + ':' + minute;
}

export const formDateString = (timeStamp) => {
    let date = new Date(timeStamp);
    let dateString = date.getUTCFullYear() + '-' + (date.getUTCMonth() + 1) + '-' + date.getUTCDate() + ' ' +
        ('0' + date.getUTCHours()).slice(-2) + ':' + ('0' + date.getUTCMinutes()).slice(-2);
    return dateString
}

export const formYYMMDD = (timeStamp) => {
    let date = new Date(timeStamp);
    let dateString = date.getUTCFullYear() + '-' + (date.getUTCMonth() + 1) + '-' + date.getUTCDate()
    return dateString
}

export const getChain = (networkId, chainId, address) => {
    let _networkId = Number(chainId)
    
    if (typeof networkId === 'string' && isValidAddress(address)) {
        _networkId = Number(networkId)
    }
    let chainInfo = isValidBtcAddress(address) || isValidDogeAddress(address) ?  Contract[networkId.toString()] : Contract[chainId.toString()] === undefined ? Contract[_networkId.toString()] === undefined ? { name: '' } : Contract[_networkId.toString()] : Contract[chainId.toString()]
    let chainName = chainInfo.name === undefined ? '' : chainInfo.name
    return chainName
}

export const getChainName = (networkId, chainId, address) => {
    let _chainId = 0
    _chainId = formatChainIdNumber(chainId)
    let chain = isValidBtcAddress(address) || isValidDogeAddress(address) ? getChain(networkId, _chainId.toString(), address) : getChain(networkId, chainId, address)
    let suffix = isTest(networkId, _chainId) ? 'Testnet' : ''
    return chain + suffix
}

export const isTest = (networkId, _chainId ) => {
    try {
        if (networkId === 'livenet') {
            return false
        } else {
            let isTest = Contract[_chainId.toString()].isTest
            return isTest    
        }

    } catch(err) {
        console.log('check test failed: ', err)
        return true
    }
}

export const getChainInfoByName = (chain, isTest) => {
    const suffix = isTest ? '_test' : ''
    let info = { networkId: Contract[chain + suffix].networkId, chainId: Contract[chain + suffix].chainId }
    return info
}


export const getScan = (networkId, chainId, address) => {
    let _chainId = 0
    if (Web3.utils.isHexStrict(chainId)) {
        _chainId = formatChainIdNumber(chainId)
    }
    const suffix = isTest(networkId, _chainId) ? '_test' : ''
    let scan = Contract[getChain(networkId, chainId, address) + suffix].scan
    if (scan === undefined) {
        scan = ''
    }
    return scan
}

export const countDecimals = function (num) {
    if (isNumeric(num)) {
        if (Math.floor(num) === num) return 0;
        return num.toString().split(".")[1].length || 0;
    } else {
        return 0
    }
}

export const isValidBtcAddress = (addr) => {
    let res = validate(addr, process.env.NEXT_PUBLIC_NETWORK === 'testnet' ? Network.testnet : Network.mainnet)
    // console.log('check btc address validity: ', res)
    return res
}

export const isValidDogeAddress = (addr) => {
    let DogeTest = /^D{1}[5-9A-HJ-NP-U]{1}[1-9A-HJ-NP-Za-km-z]{32}$/
    return DogeTest.test(addr)
}

export const checkDevice = () => {
    const ua = navigator.userAgent;
    const isIOS = /iphone|ipad|ipod|ios/i.test(ua);
    const isAndroid = /android|XiaoMi|MiuiBrowser/i.test(ua);
    return isIOS || isAndroid;
}

export const scrollToMission = (element) => {
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start',
      });
    }
  };


export const formatChainIdNumber = (chainId) => {
    if (chainId !== undefined) {
        let number
      if (Web3.utils.isHexStrict(chainId)) {
        number = Web3.utils.hexToNumber(chainId)
      } else {
        number = Number(chainId)
      }
      return number
    } else {
        return 0
    }
}

export function formatNumber(num) {
    if (num >= 1e9) return (num / 1e9).toFixed(3) + 'B';
    if (num >= 1e6) return (num / 1e6).toFixed(3) + 'M';
    if (num >= 1e3) return (num / 1e3).toFixed(3) + 'K';
    return num;
  }

export const stringWithCommas = (x) => {
    const absNum = Math.abs(Number(x)) 
    if (Number(x) === 0) return '0';
    if (absNum < 1e-6 || absNum >= 1e+6) {
        return formatNumber(x)
    } else {
        return Number(x).toLocaleString('en-US', { maximumFractionDigits: 8 })
    }
}



function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
  
function deepEqual(obj1, obj2) {
    if (obj1 === obj2) {
      return true;
    }
  
    if (!isObject(obj1) || !isObject(obj2)) {
      return false;
    }
  
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
  
    if (keys1.length !== keys2.length) {
      return false;
    }
  
    for (const key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
  
    return true;
}
  
export const arraysOfObjectsAreEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false;
    }
  
    for (let i = 0; i < arr1.length; i++) {
      if (!deepEqual(arr1[i], arr2[i])) {
        return false;
      }
    }
  
    return true;
}

export const toSmartNumber = (num) => {
    if (num > 100000000000) {
        return num.toExponential()
    }
} 

export const mergeObjArrays = (arr1, arr2) => {
    const map = new Map();
  
    arr1.forEach(item => map.set(item.id, item));
    arr2.forEach(item => map.set(item.id, { ...map.get(item.id), ...item }));
  
    return Array.from(map.values());
  };


export const mergeStringArrays = (arr1, arr2) => {
    return [...new Set([...arr1, ...arr2])];
  };

export const roundDownToEven = (num) => {
    // Floor the number to get the largest integer less than or equal to the number
    let flooredNum = Math.floor(num);

    // Check if the floored number is even
    if (flooredNum % 2 === 0) {
        return flooredNum;
    } 

    // If the floored number is odd, subtract 1 to make it even
    return flooredNum - 1;
}